import React from 'react';

import MaterialTable from 'material-table';
import { IconButton, Switch } from '@material-ui/core';
import { FaSync } from 'react-icons/fa';

import { formatDateAndTime } from 'utils/time';
import { boolSort, dateSort, textSort } from 'components/Table';
import withSpinner from '../../components/withSpinner';

const isActiveTask = status => status === 'active' || status === 'running';

const tableProps = (title, field, sort, center) => ({
  cellStyle: { padding: '4px 15px' },
  headerStyle: {
    padding: '4px 15px',
    textAlign: center ? 'center' : 'left',
    userSelect: 'none',
  },
  title,
  field,
  customSort: sort ? sort(field) : undefined,
});

const Spinner = withSpinner(FaSync);

class Tasks extends React.Component {
  render() {
    const { tasks, startTask, stopTask, runTask, refreshTaskList } = this.props;

    return (
      <div>
        <MaterialTable
          elevation={0}
          xs={12}
          options={{
            pageSizeOptions: [5, 10, 20],
            pageSize: 10,
            toolbar: true,
            paging: true,
            emptyRowsWhenPaging: false,
            search: true,
          }}
          columns={[
            {
              ...tableProps('Name', 'name', textSort),
              defaultSort: 'asc',
            },
            {
              ...tableProps('Last run', 'updatedAt', dateSort),
              render: ({ updatedAt }) => (
                <div>{updatedAt ? formatDateAndTime(updatedAt) : null}</div>
              ),
            },
            {
              ...tableProps('Next run', 'nextRun', dateSort),
              render: ({ nextRun }) => (
                <div>{nextRun ? formatDateAndTime(nextRun) : null}</div>
              ),
            },
            tableProps('Cron Job', 'cronExp', textSort),
            {
              ...tableProps('Active', 'status', null, true),
              customSort: boolSort('status', isActiveTask),
              render: ({ status, type }) => (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingRight: 18,
                  }}
                >
                  <Switch
                    color="primary"
                    checked={isActiveTask(status)}
                    disabled={status === 'running'}
                    onChange={() =>
                      status === 'idle' ? startTask(type) : stopTask(type)
                    }
                  />
                </div>
              ),
            },
            {
              ...tableProps('Update now', null, null, true),
              render: ({ status, type }) => (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {status === 'running' ? (
                    <Spinner style={{ color: 'primary' }} />
                  ) : (
                    <IconButton
                      color="primary"
                      onClick={() => runTask(type)}
                      disabled={!isActiveTask(status)}
                      style={{ outline: 'none', padding: 0 }}
                    >
                      <FaSync />
                    </IconButton>
                  )}
                </div>
              ),
              sorting: false,
            },
          ]}
          data={tasks}
          title={'Tasks'}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: refreshTaskList,
            },
          ]}
        />
      </div>
    );
  }
}

export default Tasks;
